import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const DeviceListPage = lazy(() => import('src/pages/devices/list'));

// ----------------------------------------------------------------------

const guardedDeviceListPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.USER_ROLE_TRANSPORTATION_ADMIN]}>
    <DeviceListPage />
  </RoleBasedGuard>
);

export const deviceAdminRoutes = [
  {
    path: 'devices',
    children: [{ element: guardedDeviceListPage, index: true }],
  },
];
